/**
 * 1430. 見積タスクフェーズ一覧
 * [GET] /quotation_task_phases
 */
import { QuotationTaskPhase } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';


const quotationTaskPhases = (): Promise<QuotationTaskPhase[]> => {
  return axios.get(`/api/quotation_task_phases`);
};

export const useQuotationTaskPhases = () => {
  return useQuery({
    queryKey: ['quotation_task_phases'],
    queryFn: () => quotationTaskPhases()
  });
};
